import Vue from "vue";
import App from "./App.vue";
import VueAnalytics from "vue-analytics";
import store from "./store/store";
import router from "./router";
import VueTouch from "vue-touch";
import find from "@/assets/polyfills/arrayFind.js";
find();

Vue.config.productionTip = false;
Vue.use(VueTouch, { name: "v-touch" });
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID
});

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount("#app");
